import { render, staticRenderFns } from "./PermissionManagement.vue?vue&type=template&id=0ff8a83a"
import script from "./PermissionManagement.vue?vue&type=script&lang=js"
export * from "./PermissionManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports